import { signal, WritableSignal } from '@angular/core';
import { UserInfo } from './user-info.model';
import { TokenInfo } from './token-info.model';
import { SelectableClient } from './selectable-client';
import { DefaultsService, ProfileService } from '../providers';

export class UserInfoView extends UserInfo {
  public SelectedClient: SelectableClient;
  public tokenInfo: TokenInfo;
  public currentSelectedClient: WritableSignal<SelectableClient | null> =
    signal(null);
  profileService: ProfileService;
  clientSettingsKey: string = 'selectedClientId';
  constructor(userinfodata: any, tokeninfo: TokenInfo) {
    super(userinfodata);
    this.SelectableClients = userinfodata.SelectableClients.map(
      (i: {
        Identifier: any;
        Code: string;
        Name: any;
        Lang: any;
        RDOAccess: any;
        RDODownloads: any;
        RDOCustomGridsEditor: any;
        RDOClientCustomGridsEditor: any;
        HasCustomGridsData: any;
        AvailableCustomGridSources: any;
        HasCustomerSelection: any;
        HasGeographyFullAccess: any;
        MQAAccess: any;
        ADMINAccess: any;
        ADMINManageUsers: any;
        MQARestricted: any;
        HasSalesRepRole: any;
        DataLastUpdated: any;
        HasOperatedData: any;
        RequiresMQACompetitionDisclaimer?: boolean;
        MaxNumDaysInStatus: any;
      }) => {
        return {
          ClientID: Number(i.Identifier),
          ClientCode: i.Code.toLowerCase(),
          ClientShortName: i.Name,
          Lang: i.Lang,
          RDOAccess: i.RDOAccess,
          RDODownloads: i.RDODownloads,
          RDOCustomGridsEditor: i.RDOCustomGridsEditor,
          RDOClientCustomGridsEditor: i.RDOClientCustomGridsEditor,
          HasCustomGridsData: i.HasCustomGridsData,
          AvailableCustomGridSources: i.AvailableCustomGridSources,
          HasCustomerSelection: i.HasCustomerSelection,
          hasGeographyFullAccess: i.HasGeographyFullAccess,
          MQAAccess: i.MQAAccess,
          ADMINAccess: i.ADMINAccess,
          ADMINManageUsers: i.ADMINManageUsers,
          MQARestricted: i.MQARestricted,
          HasSalesRepRole: i.HasSalesRepRole,
          DataLastUpdated: i.DataLastUpdated,
          HasOperatedData: i.HasOperatedData,
          RequiresMQACompetitionDisclaimer:
            i.RequiresMQACompetitionDisclaimer ?? false,
          MaxNumDaysInStatus: i.MaxNumDaysInStatus,
        };
      }
    ) as Array<SelectableClient>;
    // token information
    this.tokenInfo = tokeninfo;

    //this.updateSelectedClient(this.SelectableClients[0]);
  }

  public updateSelectedClient = (
    client: SelectableClient,
    defaultsService?: DefaultsService
  ): void => {
    if (client === null) {
      this.SelectedClient = client;
      this.currentSelectedClient.set(null);
    } else {
      defaultsService?.getDefaultLabels(client.ClientID);
      if (
        !defaultsService?.filterDefaultsLoading() &&
        defaultsService?.filterDefaultsClient() !== client.ClientID
      ) {
        defaultsService?.getFilterDefaults(client.ClientID);
      }
      const currentClient = this.SelectableClients.find(
        (c) => c.ClientID === client.ClientID
      );
      if (currentClient) {
        this.currentSelectedClient.set(currentClient);
      } else {
        this.currentSelectedClient.set(null);
      }
      this.SelectedClient = client;
      this.HasDownloads = false;
      this.Lang = client.Lang ? client.Lang : this.Lang;
      if (this.tokenInfo) {
        const rolebyclientlist = <Array<string>>(
          this.tokenInfo.getClaimValue(
            'http://urn:rouse:identity:claims:userrole'
          )
        );
        if (rolebyclientlist) {
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let i = 0; i < rolebyclientlist.length; i++) {
            const c = rolebyclientlist[i].split(':')[0];
            const r = rolebyclientlist[i].split(':')[1];
            if (c === client.ClientCode && r === 'downloaduser') {
              this.HasDownloads = true;
            }
          }
        }
      }
    }
  };
}
